import Crud from '../views/Atendimento/Crud'
import Entity from '../views/Atendimento/View'

let routes = {
    path: '/atendimentos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/atendimentos/view/:id?',
            name: 'ViewAtendimento',
            component: Entity,
            meta: {
                pageTitle: "Visualizar Atendimentos",
                breadcrumb: [
                    {
                        text: "Atendimentos",
                        active: false,
                        to: '/atendimentos',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/atendimentos',
            name: 'list-atendimentos',
            component: Crud,
            meta: {
                pageTitle: "Lista de Atendimentos",
                breadcrumb: [
                    {
                        text: "Atendimentos",
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
